<template>
  <h2 class="border-l-6 text-xl pl-4 mb-5 border-red-400">
    <slot />
  </h2>
</template>
